class StickyProductForm extends HTMLElement {
  connectedCallback() {
    this.observeProductForm();
    this.productForm = this.closest('product-form');
    this.sectionId = this.productForm.dataset.sectionId;
  }

  disconnectedCallback() {
    this.unsubscribeVariantChanged();
    this.unsubscribeProductChanged();
  }

  /**
   * Observe the product form.
   */
  observeProductForm() {
    const productForm = document.querySelector('product-form');

    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
      if (window.innerWidth <= 768) {
        if (isIntersecting) {
          this.querySelector('[data-sticky-add-to-cart-wrapper]').style.transform = '';
          this.classList.remove('has-sticky-atc');
          this.style.minHeight = '';
        } else {
          // Keep the in-flow height when the wrapper turns fixed, its content (e.g. discount code) varies in height
          if (!this.classList.contains('has-sticky-atc')) {
            this.style.minHeight = `${this.offsetHeight}px`;
          }
          this.classList.add('has-sticky-atc');
          this.querySelector('[data-sticky-add-to-cart-wrapper]').style.transform =
            'translateY(-7rem)';
        }
      }
    });

    observer.observe(productForm);
  }
}

customElements.define('sticky-add-to-cart', StickyProductForm);
